export default "__VITE_ASSET__BPf7DZfp__"